/**
 * @generated SignedSource<<7b3a6c613c4e304ae5085729272a64be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JcsProjectMenu$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AsyncJcsProjectMenuContent_jiraProject" | "ProjectActions" | "ProjectExpandableMenuItem">;
  readonly " $fragmentType": "JcsProjectMenu";
};
export type JcsProjectMenu$key = {
  readonly " $data"?: JcsProjectMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"JcsProjectMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JcsProjectMenu",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectExpandableMenuItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "AsyncJcsProjectMenuContent_jiraProject"
    },
    {
      "kind": "FragmentSpread",
      "name": "ProjectActions"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "f77866a9d2f2a3f30e3aa9a12a8119eb";

export default node;
